module.exports = __webpack_public_path__ + "static/media/banner-img-wrp-img-5.9157f70f.png";